export default __webpack_public_path__ + "static/media/client-14.abd3849a.png";